import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';
import TopicCard from '@/components/feature/TopicCard';
import StatusBadge from '@/components/base/StatusBadge';
import { topics } from '@/mocks/topics';

export default function HotTopicsSection() {
  const byHeat = [...topics].sort((a, b) => b.heat - a.heat);
  const featured = byHeat.slice(0, 3);
  const rest = byHeat.slice(3, 7);
  const debunked = topics.filter((item) => item.status === 'debunked').slice(0, 4);

  return (
    <section id="hot" className="w-full border-b border-background-200 bg-background-100/50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionTitle
            eyebrow="Trending Now"
            title="正在被求证的话题"
            desc="热度越高，越容易被情绪带着走。这里按讨论热度排序，点击即可看到完整的来源清单与结论。"
          />
          <Link
            to="/topics"
            className="inline-flex flex-none items-center gap-2 whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部话题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {featured.map((topic) => (
            <TopicCard key={topic.id} topic={topic} />
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6 lg:col-span-2">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-time-line text-primary-600"></i>
              最新求证动态
            </h3>
            <div className="mt-2">
              {rest.map((topic) => (
                <TopicCard key={topic.id} topic={topic} variant="compact" />
              ))}
            </div>
          </div>

          <aside className="rounded-xl border border-accent-200 bg-accent-50 p-5 md:p-6">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-accent-900">
              <i className="ri-shield-check-line"></i>
              辟谣速报
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-accent-800/90">
              这些说法已经被核实为不成立，转发前不妨先看一眼。
            </p>
            <ul className="mt-5 space-y-4">
              {debunked.map((topic) => (
                <li key={topic.id} className="border-l-2 border-accent-300 pl-4">
                  <Link
                    to={`/topic/${topic.id}`}
                    className="font-heading text-sm font-semibold leading-snug text-accent-950 transition-colors hover:text-primary-600"
                  >
                    {topic.title}
                  </Link>
                  <div className="mt-2 flex items-center gap-2">
                    <StatusBadge status={topic.status} withShort />
                    <span className="font-label text-xs text-accent-700">{topic.date}</span>
                  </div>
                </li>
              ))}
            </ul>
            <Link
              to="/archive"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap font-label text-sm text-accent-800 transition-colors hover:text-accent-950"
            >
              进入辟谣档案
              <i className="ri-arrow-right-line"></i>
            </Link>
          </aside>
        </div>
      </div>
    </section>
  );
}